/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendMissingInfoFollowUpRequest
 */
export interface SendMissingInfoFollowUpRequest {
    /**
     * Stable opaque key for this logical attempt; do not replace it after a timeout or uncertain result
     */
    idempotency_key: string;
    /**
     * Opaque revision for the exact draft reviewed by the sender
     */
    expected_draft_revision: string;
}

/**
 * Check if a given object implements the SendMissingInfoFollowUpRequest interface.
 */
export function instanceOfSendMissingInfoFollowUpRequest(value: object): value is SendMissingInfoFollowUpRequest {
    if (!('idempotency_key' in value) || value['idempotency_key'] === undefined) return false;
    if (!('expected_draft_revision' in value) || value['expected_draft_revision'] === undefined) return false;
    return true;
}

export function SendMissingInfoFollowUpRequestFromJSON(json: any): SendMissingInfoFollowUpRequest {
    return SendMissingInfoFollowUpRequestFromJSONTyped(json, false);
}

export function SendMissingInfoFollowUpRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMissingInfoFollowUpRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idempotency_key': json['idempotency_key'],
        'expected_draft_revision': json['expected_draft_revision'],
    };
}

export function SendMissingInfoFollowUpRequestToJSON(json: any): SendMissingInfoFollowUpRequest {
    return SendMissingInfoFollowUpRequestToJSONTyped(json, false);
}

export function SendMissingInfoFollowUpRequestToJSONTyped(value?: SendMissingInfoFollowUpRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idempotency_key': value['idempotency_key'],
        'expected_draft_revision': value['expected_draft_revision'],
    };
}

